import React from "react";
import TextElement from "./TextElement";
import ImageElement from "./ImageElement";
import { calculateBoundingBoxForSelectedElements } from "../../../../common/layer";

const BoxDragPreview = ({ layer, design }) => {
  const elements = [],
    boundingbox = calculateBoundingBoxForSelectedElements(design, layer);

  layer.image_elements.forEach((imageElement, index) => {
    if (!imageElement.is_selected) {
      return;
    }
    elements.push(
      <div key={'wrapper-${2000 + imageElement.id}'}>
        <ImageElement
          key={1000 + imageElement.id}
          offsetX={boundingbox.minX}
          offsetY={boundingbox.minY}
          layerId={layer.layer_id}
          index={index}
          imageElement={imageElement}
          design={design}
          disableInteractivity={true}
        />
      </div>
    );
  });

  layer.text_elements.forEach((textElement, index) => {
    if (!textElement.is_selected) {
      return;
    }
    elements.push(
      <div key={'wrapper-${2000 + textElement.id}'}>
        <TextElement
          key={2000 + textElement.id}
          offsetX={boundingbox.minX}
          offsetY={boundingbox.minY}
          layerId={layer.layer_id}
          index={index}
          textElement={textElement}
          design={design}
          disableInteractivity={true}
        />
      </div>
    );
  });

  const styles = {
    position: "relative",
    display: "block",
    width: `${boundingbox.maxX - boundingbox.minX}px`,
    height: `${boundingbox.maxY - boundingbox.minY}px`,
    boxShadow: "0px 0px 0px 1px #fff, 0px 0px 0px 2px #37455a",
  };
  return <div style={styles}>{elements}</div>;
};

export default BoxDragPreview;
